module.exports = {
	// 系统名称
  title: "平台运维基础管理端"
};
